/* NIBBLE & NABBLE 2.0 — SCROLL-GATED REVEALS (editor-safe) */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = window.Shopify && window.Shopify.designMode;

  var CHILD_SELECTOR = '.nn-product-card, .nn-category-card, .nn-value-card, .nn-event-card, .nn-stat, .nn-testimonial, .nn-instagram__tile, .nn-cat-card, .nn-section-header, .nn-grid > *';

  function gateSections() {
    var main = document.getElementById('main-content');
    if (!main) return;
    var sections = main.querySelectorAll(':scope > .shopify-section');
    sections.forEach(function (sec, i) {
      if (sec.dataset.nnGated) return;
      sec.dataset.nnGated = '1';
      if (sec.querySelector('[data-no-reveal]')) return;      /* per-section opt-out */
      var isHero = !!sec.querySelector('.nn-hero');
      if (i === 0 || isHero) return;                           /* hero/first visible immediately */
      sec.classList.add('nn-gate');
      var kids = sec.querySelectorAll(CHILD_SELECTOR);
      kids.forEach(function (k, j) {
        if (j < 12) { k.classList.add('nn-gate-child'); k.style.transitionDelay = (80 + j * 70) + 'ms'; }
      });
    });
  }

  function revealAll() {
    document.querySelectorAll('.nn-gate').forEach(function (el) { el.classList.add('nn-gate--in'); });
  }

  var observer = null;
  function observe() {
    if (reduced || inEditor || !('IntersectionObserver' in window)) { revealAll(); return; }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('nn-gate--in'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    }
    document.querySelectorAll('.nn-gate:not(.nn-gate--in)').forEach(function (el) { observer.observe(el); });
  }

  /* legacy [data-reveal] inner elements keep working */
  function observeLegacy() {
    var els = document.querySelectorAll('[data-reveal]:not(.revealed)');
    if (!els.length) return;
    if (reduced || inEditor || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('revealed'); }); return; }
    var o = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('revealed'); o.unobserve(e.target); } });
    }, { threshold: 0.1 });
    els.forEach(function (el) { o.observe(el); });
  }

  /* count-up numbers when revealed */
  function countUps() {
    var els = document.querySelectorAll('[data-countup]:not([data-counted])');
    if (!els.length) return;
    function run(el) {
      el.dataset.counted = '1';
      var raw = el.textContent.trim();
      var num = parseFloat(raw.replace(/[^0-9.]/g, ''));
      if (isNaN(num)) return;
      var prefix = raw.match(/^[^0-9]*/)[0], suffix = raw.match(/[^0-9.]*$/)[0];
      if (reduced) return;
      var start = null, dur = 1200;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + Math.round(num * eased) + suffix;
        if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var o = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); o.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { o.observe(el); });
  }

  /* scroll progress bar */
  function progressBar() {
    var bar = document.getElementById('nn-progress');
    if (!bar) return;
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? h.scrollTop / max : 0) + ')';
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function boot() { gateSections(); observe(); observeLegacy(); countUps(); progressBar(); }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }

  /* safety net: if anything is still hidden after 4s, show it */
  setTimeout(revealAll, 4000);

  /* theme editor: never hide re-rendered sections */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.closest('.shopify-section') || e.target;
    s.classList.add('nn-gate--in');
    observeLegacy(); countUps();
  });
})();
